import { Component, OnInit } from '@angular/core';
import { City } from './city';
import { CityService } from './city.service';
import { Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { UtilityService } from  '../utility.service';
import { StateService } from '../state/state.service';
import { State } from '../state/state';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-city',
  templateUrl: './city.component.html',
  styleUrls: ['./city.component.css']
})
export class CityComponent implements OnInit {

  
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  city = new City();
  citydata : any = {}
  cities: City[];
  states: State[];
  submitted = false;
  message: string;
  cityForm: FormGroup;
  totalrecord:number;
cityFilter: any = { cityname: '' };
public isupdate = false;
public FormName = "Add City";

  constructor(
    private cityService: CityService,
    private stateService: StateService,
    private route: ActivatedRoute,
    private util:UtilityService, 
    public toastr: ToastrManager,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router,
    private formBuilder: FormBuilder,
    private location: Location,
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.city.active = 1;
    this.getStates();
    this.getCities();
    this.cityForm = this.formBuilder.group({			
      cityname: [this.city.cityname,[Validators.required, Validators.required]],
      stateid: [this.city.stateid,[Validators.required, Validators.required]],
      active: [this.city.active,[Validators.required, Validators.required]]
    });	
  }

  // convenience getter for easy access to form fields
get f() {
  return this.cityForm.controls
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.cityForm.invalid) {
        return this.util.showError("Please enter required fields.");		
    }
  else{
    
    if(this.isupdate){
      this.cityForm.get('cityname').clearValidators();
      this.cityForm.get('cityname').updateValueAndValidity();
      this.cityForm.get('stateid').clearValidators();
			this.cityForm.get('stateid').updateValueAndValidity();
      this.update();
    }
    else{
      this.cityForm.get('cityname').clearValidators();
      this.cityForm.get('cityname').updateValueAndValidity();
      this.cityForm.get('stateid').clearValidators();
			this.cityForm.get('stateid').updateValueAndValidity();
      this.addCity();
    }
  }
}
 addCity() {
  //this.submitted = true;

  this.save();
}

 private save(): void {
   this.citydata = this.city;
   this.citydata.createdby = this.auth.currentUserValue.userid
   this.cityService.addCity(this.citydata)
       .subscribe(() => {
		   this.util.showSuccess("City added successfully.");             
			this.getCities();
			this.city = new City(); 
	   });
    
     this.isupdate= false;
    //   this.goBack();  //for Redirecting to the list view     
 } 


  update(): void {
    this.submitted = true;
    this.citydata = this.city;
    this.citydata.modifiedby = this.auth.currentUserValue.userid;
    this.citydata.modifiedon = Date.now();
    this.cityService.updateCity(this.citydata)
        .subscribe(() => {
		
		this.util.showSuccess("City update successfully.");
        this.city = new City(); 
        this.isupdate= false;
		
        this.getCities();
  });
        this.FormName ="Add City";
  }
 
  delete(cityid): void {
    this.submitted = true;
    this.cityService.deleteCity(cityid)
        .subscribe(()=> this.message = "City Deleted Successfully!");
  }
 
  goBack(): void {
    this.location.back();
  }

  getCities() {
    this.spinnerService.show();
    return this.cityService.getCities()
               .subscribe(
                 cities => {                
                  this.cities = cities
                  console.log(this.cities);
                  this.spinnerService.hide();
				          this.totalrecord =  this.cities.length;
                 }
                );
 }
getCity(cityid) {
  return this.cityService.getCity(cityid)
      .subscribe(
        city => {                
        this.city = city
        console.log(this.city);
        this.FormName ="Update City";
        this.isupdate=true;
        }
      );
}

  getStates() {
    return this.stateService.getStates()
               .subscribe(
                 states => {
                  this.states = states.filter(item => item.active == 1);
                 }
                );
 }
 
  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}

}
